var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.500000, 2.250000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,14.24925 C11.328,14.24925 12,13.57725 12,12.74925 L12,8.24925 L10.5,8.24925 L10.5,12.74925 L1.5,12.74925 L1.5,3.74925 L6,3.74925 L6,2.24925 L1.5,2.24925 C0.672,2.24925 0,2.92125 0,3.74925 L0,12.74925 C0,13.57725 0.672,14.24925 1.5,14.24925 L10.5,14.24925 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9 1.49925 11.6895 1.49925 3.21975 9.969 4.28025 11.0295 12.75 2.55975 12.75 5.24925 14.25 5.24925 14.25 -0.00075 9 -0.00075"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.fd7c38159773d3a0e42a74956550f4c5.svg";
export { ForwardRef as ReactComponent };